// Header
$(function(){
  var headerHeight = $(".header-wrapper").height();
  var announcementBarHeight = $(".announcement-bar").height();
  //   Main Content
  if($(".header-wrapper").hasClass("transparent-header")){
    $(".template-index #MainContent").css("margin-top", `-${headerHeight}px`);
  }
  //   Header Fixed
  $(window).scroll(function(){
    headerHeight = $(".header-wrapper").height()
    announcementBarHeight = $(".announcement-bar").height();
    if( $(window).scrollTop() > announcementBarHeight ){
      $(".header-wrapper").addClass("stickyHeader");
      if($(".header-wrapper").hasClass("transparent-header")){
        $(".template-index #MainContent").css("margin-top", `0`);
      }
    }else{
      $(".header-wrapper").removeClass("stickyHeader");
      if($(".header-wrapper").hasClass("transparent-header")){
        $(".template-index #MainContent").css("margin-top", `-${headerHeight}px`);
      }
    }
  });
});

// Product Tabs Bar Scroll
$(function(){
  $(window).scroll(function(){
    if($(".template-product .product-tabs-bar").length) {
      if($(window).scrollTop() +($(window).height())*1/6  > $(".template-product .product-tabs-bar").offset().top){
        $(".template-product .product-tabs-bar").addClass("stickyNav");
      }else{
        $(".template-product .product-tabs-bar").removeClass("stickyNav");
      }
    }
  });
  $('.template-product .product-tabs-bar .product-tabs-bar-container .tabs-bar-item').click(function(){
    $(this).addClass("active").siblings().removeClass("active");
    let target = $(this).attr('data-id');
    if($(`.section-${target}`).length > 0) {
      $("html, body").animate({
        scrollTop: $(`.section-${target}`).eq(0).offset().top - 150 + "px"
      }, 500);
      return false;
    }
  });
});
$(function(){
  if ($(window).width() > 1000) {
    $(window).scroll(function() {
      $(".animation-box").each(function() {
        if ($(window).scrollTop() + ($(window).height()) * 2 / 3 > $(this).offset().top) {
          $(this).addClass("animate-text")
        } else {
          $(this).removeClass("animate-text")
        }
      })
    })
  }
});
// Product Mobile Toggle Title 
$(function(){
  $(".mobile-toggle-title .mobile-toggle-title-wrapper").click(function(){
    var toggleId = $(this).attr("data-id");
    console.log("toggleId: ", toggleId);
    if($(`.section-${toggleId}`).is(":hidden")){
      //       $(this).find(".toggle-btn").html(`<svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1H15" stroke="black" stroke-width="1.7402" stroke-linecap="round" stroke-linejoin="round"/></svg>`);
      $(this).find(".toggle-btn").addClass("active");
    }
    else{
      //       $(this).find(".toggle-btn").html(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8H15" stroke="black" stroke-width="1.7402" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 15L8 1" stroke="black" stroke-width="1.7402" stroke-linecap="round" stroke-linejoin="round"/></svg>`);
      $(this).find(".toggle-btn").removeClass("active");
      if($(`.featured-multicolumn .slider-mobile-gutter .multicolumn-list.slick-slider`).length > 0) {
        $(`.featured-multicolumn .slider-mobile-gutter .multicolumn-list.slick-slider`).slick('unslick');
      }
    }
    $(`.section-${toggleId}`).slideToggle();
    if($(`.section-${toggleId}.featured-multicolumn`).length > 0) {
      $(`.section-${toggleId}.featured-multicolumn .slider-mobile-gutter .multicolumn-list`).slick({
        arrows: false,
        draggable: true,
        speed: 500,
        centerMode: true,
        centerPadding: '25%',
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      });
    }
  });
});

// Product Toggle Accordion
$(function(){
  $(".product__accordion.accordion .title-box").click(function() { 
    if($(this).siblings(".accordion__content").is(":hidden")){
      $(this).find(".toggle-btn").addClass("active");
    }
    else{
      $(this).find(".toggle-btn").removeClass("active");
    }
    $(this).siblings(".accordion__content").slideToggle();
  });
});

// Mobile Sidebar
$(function(){
  if ($(window).width() < 1000) {
    $(".header .menu-drawer-container").click(function() {
      var menuDrawer = $('#menu-drawer').css('visibility')
      if(menuDrawer == 'hidden'){
        $(this).addClass("active");
      } else{
        $(this).removeClass("active");
        $(".header .menu-drawer-container #menu-drawer ").css("transition", "all 0.2s linear");
      }
    });
    $(".header .menu-drawer-container #menu-drawer .menu-drawer__menu .menu-drawer__menu-item").click(function(e) {
      e.stopPropagation();
      var submenuElement = $(this).siblings(".menu-drawer__submenu");
      var submenuDrawer = $(this).siblings(".menu-drawer__submenu").css('visibility')
      if(submenuDrawer == 'hidden'){
        submenuElement.addClass("active");
      } else{
        submenuElement.removeClass("active");
      }
    });
    $(".header .menu-drawer-container #menu-drawer .menu-drawer__menu .menu-drawer__submenu .menu-drawer__close-button").click(function(e) {
      e.stopPropagation();
      var submenuElement = $(this).parent(".menu-drawer__submenu");
      var supmenuElement = $('.menu-drawer__inner-submenu').parents(".menu-drawer__submenu");
      if(submenuElement.hasClass("active")){
        submenuElement.removeClass("active");
      }
      else{
        supmenuElement.removeClass("active");
      }
    });
  };
});

// Collection Featured Product
$(function(){
  var len = $(".collection-fea-pro").length;
  if(len > 0) {
    var leftSwiperArr = [];
    var rightSwiperArr = [];
    for(let i = 0; i < len; i++) {
      var sectionId = $(".collection-fea-pro").eq(i).attr("data-section-id");
      rightSwiperArr[i] = new Swiper(`.collection-fea-pro-${sectionId} .product-images-right-container`, {
        slidesPerView: 2,
        slidesPerGroup: 1,
        initialSlide: 1,
        spaceBetween : 30,
        loop: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        breakpoints: {
          1600: {
            spaceBetween: 20
          }
        }
      });
      leftSwiperArr[i] = new Swiper(`.collection-fea-pro-${sectionId} .product-images-left-container`, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        breakpoints: {
          790: {
            spaceBetween: 40,
            pagination: {
              el: `.swiper-pagination-${sectionId}`,
              clickable :true,
            },
          }
        }
      });
      if($(window).width() > 791) {
        $(`.collection-fea-pro-${sectionId} .slider-button.swiper-button-prev`).click(function(){
          leftSwiperArr[i].slidePrev();
          rightSwiperArr[i].slidePrev();
        });
        $(`.collection-fea-pro-${sectionId} .slider-button.swiper-button-next`).click(function(){
          leftSwiperArr[i].slideNext();
          rightSwiperArr[i].slideNext();
        });
        leftSwiperArr[i].on('slidePrevTransitionStart', function () {
          rightSwiperArr[i].slidePrev();
        });
        leftSwiperArr[i].on('slideNextTransitionStart', function () {
          rightSwiperArr[i].slideNext();
        });
      }
      if($(window).width() < 790 && rightSwiperArr[i]) {
        rightSwiperArr[i].destroy(false);
      }
    }
  }
});